import { render } from "./CardFarms.vue?vue&type=template&id=15d6f9bc"
import script from "./CardFarms.vue?vue&type=script&lang=js"
export * from "./CardFarms.vue?vue&type=script&lang=js"

import "./CardFarms.vue?vue&type=style&index=0&id=15d6f9bc&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__